export const getElement: {
  <T extends Element = HTMLElement>(querySelector: string, optional: true): T | undefined;
  <T extends Element = HTMLElement>(querySelector: string, optional: false): T;
  <T extends Element = HTMLElement>(querySelector: string, optional?: undefined): T;
} = <T extends Element = HTMLElement>(querySelector: string, optional?: boolean) => {
  const required = optional === false;
  const element = document.querySelector<T>(querySelector);
  if (required && !element) {
    throw new Error(`Element with query selector ${querySelector} not found`);
  }

  return element;
};

export function getElements<T extends Element = HTMLElement>(querySelector: string, optional: true): T[] | undefined;
export function getElements<T extends Element = HTMLElement>(querySelector: string, optional: false): T[];
export function getElements<T extends Element = HTMLElement>(querySelector: string, optional?: undefined): T[];

export function getElements<T extends Element = HTMLElement>(
  querySelector: string,
  optional?: boolean,
): T[] | undefined {
  const elements = Array.from(document.querySelectorAll<T>(querySelector));

  if (optional === false && elements.length === 0) {
    throw new Error(`No elements found for query selector: ${querySelector}`);
  }

  return elements.length === 0 && optional === true ? undefined : elements;
}
